import { createSlice } from "@reduxjs/toolkit";

export const popupModelDataSlice = createSlice({
    name: 'popupModelData',
    initialState: {
        data: [],
        dataIndex: 0
    },
    reducers:{
        setData(state, action) {
            state.data = action.payload
        },
        setIndex(state, action) {
            state.dataIndex = action.payload
        }
    }
})


export const popupModelDataActions = popupModelDataSlice.actions